<div class="container">
  <div class="row eb-cards mt-4 mx-0">
    <div class="col-lg-2 col-md-2 col-xl-3"></div>
    <div class="col-12 col-lg-8 col-md-8 col-xl-6">
      <div class="border-0 card login-info p-2 border_radius_15px">
        <h3 class="font-weight-bold mt-2 mt-lg-4 text-center text-lg-center text-md-center">New User Registration</h3>
        <div class="m-3 m-lg-3 m-md-3 mx-0 row" *ngIf="!enableWebAppVersionV6">
          <div class="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12 mb-lg-3 mb-xl-2 mt-3 mt-lg-3 mt-xl-0 pl-0 pr-0">
            <div class="border-0">
              <div class="mx-0 p-2 pb-3 pt-3 row mt-3 error-message-container">
                <div class="col-xl-12 col-12">
                  <p class="font-16 font-weight-normal mb-0 pt-2 error-text">
                    <span
                      >You are not authorized to access this version of the site at this time. Please contact your
                      company administrator.</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="float-lg-end float-right float-md-right float-xl-right mb-4 mb-lg-4 mt-4 mt-lg-4 text-lg-end employee_verification">
            <a
              style="color: #000; padding: 11px"
              class="bold btn btn-secondary d-inline font-12 text-center w-auto pl-4 pr-4 mr-xl-2 mr-md-2 mr-lg-2 mr-2"
              [routerLink]="'/'">
              Back
            </a>
          </div>
        </div>
        <div class="row mx-0 pl-0 pr-0 col-lg-12">
          <ng-template #errorContainer> </ng-template>
        </div>
        <div class="mt-3 mt-lg-3 mt-md-3 mx-0 row" *ngIf="enableWebAppVersionV6">
          <div class="col-lg-3 col-md-2 col-xl-2"></div>
          <div class="col-lg-6 col-md-8 col-xl-8">
            <div class="step-container d-flex justify-content-between mt-3 mt-lg-4">
              <div class="step-circle-wb mb-0">1</div>
              <div class="step-line">-----</div>
              <div class="step-circle mb-0">2</div>
              <div class="step-line">-----</div>
              <div class="step-without-circle mb-0">3</div>
            </div>
          </div>
          <div class="col-lg-3 col-md-2 col-xl-2"></div>
          <div class="col-lg-12 col-md-12 employee_verification">
            <h4 class="font-weight-bold text-center text-lg-center text-md-center">Let’s verify your account</h4>
          </div>

          <form [formGroup]="registrationForm">
            <div class="row col-lg-12 col-md-12 mt-4 mt-lg-4">
              <div class="col-lg-6 col-md-6">
                <mdb-form-control>
                  <input
                    mdbInput
                    id="firstName"
                    formControlName="firstName"
                    type="text"
                    class="form-control input-height" />
                  <label mdbLabel class="form-label" for="firstName">First Name</label>
                </mdb-form-control>
                <div
                  class="error edenred-border-8"
                  *ngIf="registrationForm.get('firstName').invalid && registrationForm.get('firstName').touched">
                  <span *ngIf="registrationForm.get('firstName').hasError('required')">First Name is required.</span>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <mdb-form-control>
                  <input
                    mdbInput
                    id="lastName"
                    formControlName="lastName"
                    type="text"
                    class="form-control input-height" />
                  <label mdbLabel class="form-label" for="lastName">Last Name</label>
                </mdb-form-control>
                <div
                  class="error edenred-border-8"
                  *ngIf="registrationForm.get('lastName').invalid && registrationForm.get('lastName').touched">
                  <span *ngIf="registrationForm.get('lastName').hasError('required')">Last Name is required.</span>
                </div>
              </div>
            </div>
            <div class="row col-lg-12 col-md-12">
              <div class="col-lg-6 col-md-6">
                <mdb-form-control>
                  <input
                    mdbInput
                    id="homeZipCode"
                    formControlName="homeZipCode"
                    type="text"
                    class="form-control mt-3 mt-lg-3 input-height"
                    minlength="5"
                    maxlength="10"
                    ebOnlyNumber
                    ebZipCode
                    (input)="dynamicFieldValidation()" />
                  <label mdbLabel class="form-label" for="homeZipCode">Home Zip Code</label>
                </mdb-form-control>
                <div
                  class="error edenred-border-8"
                  *ngIf="registrationForm.get('homeZipCode').invalid && registrationForm.get('homeZipCode').touched">
                  <span *ngIf="registrationForm.get('homeZipCode').hasError('required')"
                    >Home Zip Code is required.</span
                  >
                  <span *ngIf="registrationForm.get('homeZipCode').hasError('pattern')">Invalid Zip Code.</span>
                </div>
              </div>
              <div class="col-lg-6 col-md-6"></div>
            </div>
            <div class="row mx-0 col-lg-12 col-md-12 mt-2 mt-lg-2">
              <p class="font-16">We’ll need to verify your account to complete your registration.</p>
            </div>
            <div class="row col-lg-12 col-md-12">
              <div class="col-lg-12 col-md-12">
                <mdb-form-control>
                  <input
                    mdbInput
                    id="Email Address"
                    formControlName="email"
                    type="text"
                    class="form-control input-height"
                    (input)="dynamicFieldValidation()" />
                  <label mdbLabel class="form-label" for="Email Address">Email Address</label>
                  <div
                    class="error edenred-border-8"
                    *ngIf="registrationForm.get('email').invalid && registrationForm.get('email').touched">
                    <span *ngIf="registrationForm.get('email').hasError('required')">Email is required.</span>
                    <span *ngIf="registrationForm.get('email').hasError('email')"
                      >Please enter a valid email address.</span
                    >
                  </div>
                </mdb-form-control>
              </div>
            </div>
            <div class="mx-0 row" *ngIf="isEmailSend">
              <div class="col-lg-12">
                <p class="toast-primary font-16 mt-3 p-3 border-left-4 d-flex rounded-end">
                  <img src="assets/images/error_outline.svg" alt="error" class="mr-3" />
                  <span
                    ><strong>Verification sent!</strong> Please check your email and click on the verification link,
                    which will expire in 30 minutes.
                  </span>
                </p>
              </div>
              <div class="mb-3 mb-lg-4 mb-md-3 employee_verification">
                <p class="font-16 mb-1">Didn’t receive an email?</p>
                <button
                  aria-label="Email"
                  (click)="emailResend()"
                  class="bold btn btn-primary d-inline font-16 mt-2 mt-md-2 pl-4 pr-4 text-center w-auto">
                  Re-Send Email
                </button>
              </div>
            </div>
            <div
              class="float-lg-end float-right float-md-right float-xl-right mb-4 mb-lg-4 mt-4 mt-lg-4 text-lg-end employee_verification">
              <button
                aria-label="verifyEnrollment"
                class="bold btn btn-primary d-inline font-12 text-center w-auto pl-4 pr-4"
                type="submit"
                (click)="sendVerificationEmail()"
                [disabled]="!registrationForm.valid || isEmailSend">
                Send Verification Email
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-xl-3"></div>
  </div>
</div>
